export default defineNuxtPlugin(async (nuxtApp) => {
  const config = useRuntimeConfig()
  const { apiUrl, clientId, bucketName } = config.public
  const timeout = 60 * 1000

  // SSR-safe: 使用 nuxtApp context 存儲狀態和 timer，避免記憶體洩漏
  if (!nuxtApp._hostTesterContext) {
    nuxtApp._hostTesterContext = {
      fastApiUrl: null,
      intervalId: null,
      hostTester: null,
    }
  }
  const ctx = nuxtApp._hostTesterContext

  // 如果已經有 interval 在運行，不重複建立
  if (ctx.intervalId) {
    return {
      provide: {
        hostTester: ctx.hostTester,
        getFastApiUrl: () => ctx.fastApiUrl,
      },
    }
  }

  const url = `https://storage.googleapis.com/${bucketName}/site_resources/${clientId}/target/target.json`
  ctx.hostTester = new HostTester(url, clientId)

  // 初始測試
  ctx.fastApiUrl = await ctx.hostTester.test()

  // 定期更新最佳 API URL
  ctx.intervalId = setInterval(async () => {
    ctx.fastApiUrl = await ctx.hostTester.test()
  }, timeout)

  // 清理機制：頁面卸載時清除 interval
  if (typeof window !== 'undefined') {
    const cleanup = () => {
      if (ctx.intervalId) {
        clearInterval(ctx.intervalId)
        ctx.intervalId = null
      }
    }

    window.addEventListener('beforeunload', cleanup)

    // Nuxt app 卸載時也清理
    nuxtApp.hook('app:unmount', cleanup)
  }

  return {
    provide: {
      hostTester: ctx.hostTester,
      getFastApiUrl: () => ctx.fastApiUrl,
    },
  }
})

class HostTester {
  constructor(url, clientId) {
    this.url = url
    this.hosts = []
    this.clientId = clientId
  }

  async init() {
    const target = await fetch(this.url)
    const { host } = await target.json()
    this.hosts = host
  }

  async test() {
    try {
      if (this.hosts.length === 0) {
        await this.init()
      }
      const { url, index } = await Promise.any(
        this.hosts.map((url, i) => {
          return this.ping(url, i)
        })
      )
      console.info(`[Network] Host ${index} is chosen. (${url})`)
      return url
    } catch (error) {
      console.error('[Network] Host Test Fail.', error)
    }
  }

  async ping(url, index) {
    let ts, response
    try {
      ts = new Date().getTime()
      response = await fetch(`${url}/health?ts=${ts}&site=${this.clientId}`)
      return { url, index }
    } finally {
      const speed = new Date().getTime() - ts
      const status = !!response?.ok ? 'Success' : 'Failure'
      console.info(`[Network] Host: ${index}, URL: ${url}, Status: ${status}, Speed: ${speed}ms`)
    }
  }
}
